// src/components/ExpandedCard.js

import React from 'react';
import { Card } from 'react-bootstrap';

const ExpandedCard = ({ children }) => {
  return (
    <Card
      className="shadow w-100 p-3 expanded-course-height"
      style={{
        position: 'relative',
        zIndex: 20,
        borderRadius: '0.5rem',
        overflow: 'hidden',
      }}
    >
      <Card.Body className="fade-in-content">
        {children}
      </Card.Body>
    </Card>
  );
};

export default ExpandedCard;
